module.exports = __webpack_public_path__ + "static/media/Palau.0cf31598.png";